import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=f0f5aa52&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=f0f5aa52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f5aa52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0f5aa52')) {
      api.createRecord('f0f5aa52', component.options)
    } else {
      api.reload('f0f5aa52', component.options)
    }
    module.hot.accept("./SearchInput.vue?vue&type=template&id=f0f5aa52&scoped=true&", function () {
      api.rerender('f0f5aa52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SearchBar/components/SearchInput.vue"
export default component.exports